import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { useSearchParams } from "react-router-dom";
import { Section } from "../components/ui";
import GuideGrid from "../components/guides/GuideGrid";
import SupportCard from "../components/home/SupportCard";
import { GUIDES_INDEX_URL, getGuideByKey } from "../data/installation-guides";

/**
 * Installation guides.
 *
 * Accepts `?product=<guide key>` so the legacy install-flow URLs
 * (`/m10-setup` and friends) can redirect here and land on the right card.
 */
function GuidesPage() {
  const [searchParams] = useSearchParams();
  const requested = searchParams.get("product");
  const highlight = requested && getGuideByKey(requested) ? requested : null;

  return (
    <>
      <Section
        eyebrow="Installation guides"
        title="Installation guides."
        description="Artome publishes installation instructions on artome.fi so they stay current. Open a guide in your browser, or download the PDF to use offline on site."
        action={
          <Link
            href={GUIDES_INDEX_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 700, color: "text.primary", whiteSpace: "nowrap" }}
          >
            All guides on artome.fi
          </Link>
        }
      >
        <GuideGrid highlightKey={highlight} />
      </Section>

      <Section sx={{ pt: 0 }}>
        <Box>
          <SupportCard />
        </Box>
      </Section>
    </>
  );
}

export default GuidesPage;
